/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2024.

!Changelog

2024
	30-12-2024
	- [BORN] This class is born. Hooray!

!Usage
	specific_instagramfeed.onready();
	
!Wishlist

	none
	
*/
  
var specific_languageswitcher = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	this.onready = function() {
		
		url 		= getUrl();

		_language 	= url[1];
		_part_1 	= url[2];
		_part_2 	= url[3];
	
		_part_1_array_nl = [
			'vleermuis',
			'comedy'
		];

		_part_1_array_en = [
			'bats',
			'comedy'
		];

		_part_2_array_nl = [
			'biografie',
			'speellijst',
			'diensten',
			'publicaties',
			'notities',
			'contact'
		];

		_part_2_array_en = [
			'biography',
			'tour-dates',
			'services',
			'publications',
			'notes',
			'contact'
		];

		/*
		Change to english *****************************************
		Change to english *****************************************
		Change to english *****************************************
		Change to english *****************************************
		*/
		if(
			_language == 'nl'
		) {

			_index_1 = _part_1_array_nl.indexOf(_part_1);
			_index_2 = _part_2_array_nl.indexOf(_part_2);

			_url_new = globalUrl + '/en';
			
			if (
				_part_2 != ''
			) {
				_url_new = _url_new + '/' + _part_1_array_en[_index_1] + '/' + _part_2_array_en[_index_2];
			} else {
				if (
					_part_1 != ''
				) {
					_url_new = _url_new + '/' + _part_1_array_en[_index_1];
				}
			}

		/*
		Change to dutch *********************************
		Change to dutch *********************************
		Change to dutch *********************************
		Change to dutch *********************************
		*/
		} else {

			_index_1 = _part_1_array_en.indexOf(_part_1);
			_index_2 = _part_2_array_en.indexOf(_part_2);

			_url_new = globalUrl + '/nl';
			
			if (
				_part_2 != ''
			) {
				_url_new = _url_new + '/' + _part_1_array_nl[_index_1] + '/' + _part_2_array_nl[_index_2];
			} else {
				if (
					_part_1 != ''
				) {
					_url_new = _url_new + '/' + _part_1_array_nl[_index_1];
				}
			}

		}		

		/*
		Change the URL
		Change the URL
		Change the URL
		Change the URL
		*/
		if (_language == 'nl') {
			// $('.js-languageswitcher-nl').attr('href', _url_new);
			$('.js-languageswitcher-en').attr('href', _url_new);
		} else {
			// $('.js-languageswitcher-en').attr('href', _url_new);
			$('.js-languageswitcher-nl').attr('href', _url_new);
		}
		
	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
	
	// none
		
}).apply(specific_languageswitcher);